import createAsyncAction from "utils/createAsyncAction";

export const UPLOAD_IMAGE_REQUESTED = "UPLOAD_IMAGE_REQUESTED";
export const UPLOAD_IMAGE_SUCCEEDED = "UPLOAD_IMAGE_SUCCEEDED";
export const UPLOAD_IMAGE_FAILED = "UPLOAD_IMAGE_FAILED";

export const uploadImageAsync = createAsyncAction(
  "images",
  "create",
  "UPLOAD_IMAGE",
  args => args,
  error => {
    throw error;
  }
);

export const UPDATE_IMAGE_REQUESTED = "UPDATE_IMAGE_REQUESTED";
export const UPDATE_IMAGE_SUCCEEDED = "UPDATE_IMAGE_SUCCEEDED";
export const UPDATE_IMAGE_FAILED = "UPDATE_IMAGE_FAILED";

export const updateImageAsync = createAsyncAction(
  "images",
  "update",
  "UPDATE_IMAGE",
  args => args,
  error => {
    throw error;
  }
);
